import { ITeamTreeQuery } from '../interfaces/team-tree.query.interface';
import { Team } from './team.model';

export class TeamTree {
    parent: {
        id: string;
        name: string;
    };
    teams: Team[];

    constructor(teamTreeQuery: ITeamTreeQuery) {
        this.parent = teamTreeQuery.parent ? { ...teamTreeQuery.parent, id: teamTreeQuery.parent.id.toString() } : null;
        this.teams = teamTreeQuery.teams.map((team) => new Team(team));
    }
}
